
angular.module('bmsApp.directives').controller('PhotoListCtrl', ['$scope', '$log', 'PhotoSvc', '$window', function ($scope, $log, PhotoSvc, $window) {

		$scope.objectReady = true;
		// $scope.photos = {
		// 	itemsPerPage: 5,
		// 	loading: true,
		// 	totalCount: 0, // total count of notes belongs to object
		// 	currentPage: 1,
		// 	pageResult: [] // currently loaded paged results
		// };
		$scope.noteAttachments = {
			loading: true,
			result: []
		};

		// Full notes

		$scope.$on('showPhotos', function () {
			$scope.loadPhotos($scope.objectType, $scope.objectId);
		});

		$scope.loadPhotos = function (objectType, objectId) {
			$scope.photos.loading = true;
			if ($scope.objectReady) {
				var indexByObjectParams = {
					count:$scope.photos.itemsPerPage,
					page:$scope.photos.currentPage,
					objectType: objectType,
					objectId: objectId
				};
				console.log(indexByObjectParams);
				PhotoSvc.indexByObject(indexByObjectParams)
					.then(function (response) {
						$scope.photos.pageResult = response.data.photo_collection;
						$scope.photos.totalCount = response.data.photo_total_count;
						$scope.photos.loading = false;
					}, function (error) {
						$log.error(error);
						$scope.photos.loading = false;
					});
			}
		};

		$scope.loadNoteAttachments = function (objectType, objectId) {
			// use the note service without a page size and extract the attachments from there
			$scope.noteAttachments.loading = true;
			if ($scope.objectReady) {
				var indexByObjectParams = {
					page: 1,
					objectType: objectType,
					objectId: objectId
				};
				NoteSvc.indexByObject(indexByObjectParams)
					.then(function (response) {
						var noteAttachments = [];
						angular.forEach(response.data.note_collection, function (noteCollection) {
							angular.forEach(noteCollection.note_attachments, function (noteAttachment) {
								noteAttachments.push(noteAttachment);
							});
						});
						$scope.noteAttachments.result = noteAttachments;
						$scope.noteAttachments.loading = false;
				}, function (error) {
					$log.error(error);
					$scope.noteAttachments.loading = false;
				});
			}
		};

		$scope.noteAttachmentView = function () {
			$scope.loadNoteAttachments($scope.objectType, $scope.objectId);
		};

		$scope.photosPageChanged = function () {
			$scope.loadPhotos($scope.objectType, $scope.objectId);
		};

		// $scope.$watchGroup(['objectType', 'objectId'], function (newValues, oldValues) {
		// 	var objectType = newValues[0];
		// 	var objectId = newValues[1];
		// 	if (angular.isString(objectType) && angular.isNumber(objectId)) {
		// 		$scope.objectReady = true;
		// 	}
		// 	else {
		// 		$scope.objectReady = false;
		// 	}
		// });

		$scope.downloadPhoto = function(filename) {
			$window.open('file/download/'+filename, '_blank');
		}

}]);
